export enum PiqEnvironment {
    DEV = 'DEV',
    ETHAN_LAB = 'ETHAN-LAB',
    INTEGRATION = 'INTEGRATION',
    PRODUCTION = 'PRODUCTION',
    REF_LAB = 'REF-LAB',
    STAGE = 'STAGE',
}
